export function newsFilter() {


    var categoryFilter = document.querySelector('.location-filter');
    var filteredPostsContainer = document.getElementById('filtered-posts-container');
    var overlayClass = 'overlay'; // CSS class for the overlay

    // Function to show the overlay
    function showOverlay() {
        filteredPostsContainer.classList.add(overlayClass);
    }

    // Function to hide the overlay
    function hideOverlay() {
        filteredPostsContainer.classList.remove(overlayClass);
    }

    // Event listeners
    categoryFilter.addEventListener('change', filterPosts);
}

// Function to filter posts
export function filterPosts() {
    
    var categoryFilter = document.querySelector('.location-filter');
    var categoryId = categoryFilter.value;
    var filteredPostsContainer = document.getElementById('filtered-posts-container');
    var overlayClass = 'filter-overlay'; // CSS class for the overlay
    var currentPage = 1; // Define currentPage here

    // Show overlay before filtering starts
    filteredPostsContainer.classList.add(overlayClass);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
        if (xhr.status === 200) { 
            var response = JSON.parse(xhr.responseText);
            filteredPostsContainer.innerHTML = response.postsHtml;
       
            // Hide overlay after filtering completes
            filteredPostsContainer.classList.remove(overlayClass);
        } else {
            console.error('Request failed. Returned status of ' + xhr.status);
            // Ensure overlay is hidden in case of error
            filteredPostsContainer.classList.remove(overlayClass);
        }
    };
    xhr.send('action=filter_posts&tag=' + categoryId);
};
